
export function init() {
    $(document).ready(function() {
      $("#select-area").select2();
      $("#select-district").select2();
    });
}
